/**
 * Formats a picker-selected calendar date for APIs that accept date-only fields.
 *
 * Example: a Madrid user selects 2026-05-13, which JS stores as
 * 2026-05-12T22:00:00.000Z. The API still needs "2026-05-13".
 */
export const formatCalendarDate = (date?: Date | null): string | undefined => {
  if (!date) {
    return undefined;
  }

  const d = new Date(date);
  if (Number.isNaN(d.getTime())) {
    return undefined;
  }

  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};
